import httpRequest from '../../common/lib/http-request';

// *************************
// FINANCIAL SERVICES
// *************************

function getRegistrationPaymentList(registrationRef) {
    return httpRequest({
        url: '/Payment/' + registrationRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function generateInvoicePdf(invoiceRef) {
    return httpRequest({
        url: '/Payment/invoice/pdf/' + invoiceRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function generateCreditCardCheckout(checkout) {
    return httpRequest({
        url: '/Registration/cc/checkout',
        method: 'POST',
        data: checkout
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getCreditCardCheckoutStatus(checkoutId) {
    return httpRequest({
        url: '/Payment/cc/checkout/' + checkoutId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

const FinancialService = { getRegistrationPaymentList, generateInvoicePdf, generateCreditCardCheckout, getCreditCardCheckoutStatus }

export default FinancialService;